import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { Stack, Typography } from '@mui/material';

interface ProtectedRouteProps {
  requiredGroup?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ requiredGroup }) => {
  const auth = useAuth();
  const location = useLocation();

  if (auth.isLoading) {
    // Optional: Show a loading spinner or message while checking auth state
    return <Stack sx={{ height: "100%", justifyContent: "center", alignItems: "center" }}><Typography>Verifying authentication...</Typography></Stack>;
  }

  if (!auth.isAuthenticated) {
    // User not authenticated, redirect to login
    // Pass the current location so we can redirect back after login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredGroup) {
    const groups = (auth.user?.profile?.["cognito:groups"] as string[] | undefined) ?? [];
    if (!groups.includes(requiredGroup)) {
      return <Navigate to="/" replace />;
    }
  }

  return <Outlet />; // User is authenticated (and authorized), render the child route component
};

export default ProtectedRoute;